let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = Promise.all([load("hPzOn"), load("ksdkh")]).then(() => parcelRequire('9E32x'));